
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SelectableBox extends Vue {
  @Prop()
  private readonly checked!: boolean;

  @Prop()
  private readonly inverse!: boolean;

  @Prop()
  private readonly value!: any;

  private select () {
    this.$emit('select', this.value);
  }
}
